<ag-charts [options]="chartOptions"></ag-charts>
<ag-charts [options]="chartOptions2"></ag-charts>